import React, { Component } from 'react';
import { HttpRequestService } from '../../services/HttpRequestService';
import { UtilsService } from '../../services/UtilsService';

class TwoFASetup extends Component {
    constructor(props) {
        super(props);
        this.http = new HttpRequestService();
        this.utils = new UtilsService();
        this.state = {
            twoFAEnabled: false,
            key: "",
            imageUri: "",
            twoFACode: "",
            message: ""
        };
        this.handleTwoFACodeChange = this.handleTwoFACodeChange.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.setup2FA = this.setup2FA.bind(this);
    }

    componentDidMount() {
        this.getData();
    }

    handleTwoFACodeChange(e) {
        this.setState({
            twoFACode: e.target.value
        })
    }

    getData() {
        this.http.get('/api/PowerD/GetTwoFASetupParams').then(data => {
            if (data && data.key) {
                this.setState({
                    twoFAEnabled: false,
                    key: data.key,
                    imageUri: data.imageUri
                });
            }
            else {
                this.setState({
                    twoFAEnabled: true,
                    message: "Two-factor authentication has already been enabled."
                });
            }
        });
    }

    setup2FA() {
        var params = {
            key: this.state.key,
            twoFACode: this.state.twoFACode
        }
        this.http.post('/api/PowerD/SetupTwoFA', params).then(data => {
            if (data) {
                this.setState({
                    twoFAEnabled: true,
                    message: "Two-factor authentication has been successfully enabled."
                });
                this.utils.success("");
            }
            else {
                this.utils.alert("Incorrect authentication code. Please try again.");
            }
        });
    }

    handleKeyUp(e) {
        if (e.keyCode === 13) {
            this.setup2FA();
        }
    }

    render() {
        return (
            <div className="page-inner">
                <div className="page-header">
                    <h4 className="page-title">Setup Two-Factor Authentication</h4>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        {this.state.twoFAEnabled &&
                            <div className="card">
                                <div className="card-body">
                                    <div className="col-md-12">
                                        <p>{this.state.message}</p>
                                    </div>
                                </div>
                            </div>
                        }
                        {!this.state.twoFAEnabled && this.state.key &&
                            <div className="card">
                                <div className="card-body">
                                    <div className="form-row">
                                        <div className="col-md-12">
                                            <div className="form-group col-md-12 text-center">
                                                <img src={this.state.imageUri}></img>
                                            </div>
                                            <div className="form-group col-md-12">
                                                <ol>
                                                    <li>Download and install an <strong>authenticator</strong> app on your mobile device. (Google Authenticatior, Microsoft Authenticator, etc.)</li>
                                                    <li>Open the authenticator app </li>
                                                    <li>Tap the '+' icon.</li>
                                                    <li>Scan the QR Code</li>
                                                    <li>Enter the code generated by the authenticator app</li>
                                                    <li>Submit</li>
                                                </ol>
                                            </div>
                                            <div className="form-group col-md-12">
                                                <label>Authentication Code</label>
                                                <input type="text" value={this.state.twoFACode} onChange={this.handleTwoFACodeChange} onKeyUp={this.handleKeyUp} className="form-control" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <button className="btn btn-primary btn-default pull-right mr-2" onClick={this.setup2FA}>Submit</button>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default TwoFASetup
